import { EmbedOpts, initialize } from '@bentley/imodeljs-embed-api';
import React, { useEffect } from 'react';
import { BuddiService } from '../../../services';

export interface DesignReviewProps {
  projectId: string;
  iModelId?: string;
  namedVersionId: string;
  defaultViewId?: string;
}

export const embedDesignReviewComponent = (serviceName?: string) =>
  serviceName === 'Design Review';

export function DesignReview({
  projectId,
  iModelId,
  namedVersionId,
  defaultViewId,
}: DesignReviewProps): JSX.Element {
  const init = async () => {
    const appOrigin = await BuddiService.getUrl('iModelWeb.Url');
    const embedOpts: EmbedOpts = {
      projectId,
      iModelId,
      changesetId: namedVersionId,
      shareViewId: defaultViewId,
      appOrigin,
    };

    const designReview = await initialize('#iframe-wrapper', {
      ...embedOpts,
    });

    setTimeout(() => designReview.forceRefresh(), 10000);
  };

  useEffect(() => {
    init().catch(error => console.error(error));
  }, []);

  return (
    <div
      id='iframe-wrapper'
      style={{
        overflow: 'hidden',
        position: 'relative',
        height: '100%',
      }}
    />
  );
}
